import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import PainSection from './components/PainSection';
import ExplanationSection from './components/ExplanationSection';
import SolutionSection from './components/SolutionSection';
import DirectorSection from './components/DirectorSection';
import TestimonialsSection from './components/TestimonialsSection';
import AccessSection from './components/AccessSection';
import FinalCtaSection from './components/FinalCtaSection';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    fbq: (...args: any[]) => void; // ★ Meta用の型定義
  }
}

export default function Home() {

  // ★ 1. ここに共通の関数を定義
  const handleCtaClick = (label: string) => {
    console.log(`🚀 CTA Clicked: ${label}`);
    // GA4イベント
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'ForHiroChiroCTA_click', {
        'event_category': 'ForHiroChiroLP_CTA',
        'event_label': label
      });
    }

    // Metaピクセルイベント
    if (typeof window !== 'undefined' && window.fbq) {
      // 標準イベント「Contact」として送る（広告最適化に強い）
      window.fbq('track', 'Contact', {
        content_name: 'どこに行ってもLP',
        content_category: 'CTA_Click',
        content_label: label
      });
    }
  };
  
  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar onCtaClick={handleCtaClick} />
      <main>
        <HeroSection onCtaClick={handleCtaClick} />
        <PainSection />
        <ExplanationSection />
        <SolutionSection />
        <DirectorSection />
        <TestimonialsSection />
        <AccessSection />
        <FinalCtaSection onCtaClick={handleCtaClick} />
      </main>
      <Footer onCtaClick={handleCtaClick} />
    </div>
  );
}